<template>
  <v-ons-page :modifier="isShowReglette ? 'perfreglette' : 'perfvert'" @init="initPage()" @show="showPage()" @deviceBackButton.prevent="backButton()">

    <v-ons-toolbar modifier="noshadow">
      <div class="left">
        <v-ons-back-button v-if="! $md" @click.prevent="backButton"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="backButton">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Mon alerte - {{ cultLabel }}</div>
      <div v-if="isShowDelete" class="right">
        <v-ons-toolbar-button @click="deleteAlerteConfirm">
          <v-ons-icon icon="trash"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="content">

      <template v-if="! isStepHistorique">
        <section class="content--perfalerte">
          <img src="../assets/imgs/icon_alert@2x.png">
          <p>
            {{ user.prenom }}, vous êtes prêt<br />
            à vendre quand le<br />
            <v-ons-toolbar-button v-if="prix && coursJour && ! client" @click="switchPrix = true" modifier="perfrecolte">
              {{ typeAlerte == 'os' ? 'prix de votre OS' : 'cours ' + coursJour.suffix }}
              <v-ons-icon icon="angle-down"></v-ons-icon>
            </v-ons-toolbar-button>
            <span v-else>
              {{ typeAlerte == 'os' ? 'prix de votre OS' : 'cours ' + coursJour.suffix }}
            </span>
            <br />atteint&nbsp;:
          </p>
        </section>

        <section v-if="isShowReglette" @click="popupSeuil.isShow = true" class="content--perfcartouche">
          <h2>{{ coursObjectif }} €/t</h2>
          <p v-if="! isShowDiff">
            <b>{{ typeAlerte == 'os' && prix.cours ? 'Prix OS' : 'Cours' }} actuel</b><br />
            {{ typeAlerte == 'os' && prix.cours ? prix.label : coursJour.label }}
          </p>
          <p v-else>
            <span :style="{ 'background-color': diffBgColor }">
              <b>
                {{ coursObjectif >= coursRef ? '+' : '-' }}
                {{ Math.abs(coursObjectif - coursRef) }} €/t
              </b>
            </span><br />
            par rapport au {{ typeAlerte == 'os' && prix.cours ? 'prix OS' : 'cours' }} actuel
          </p>
          <div></div>
        </section>
      </template>

      <template v-else>
        <section class="content--perfsimul">
          <div>
            <p>
              <span v-if="countCampagne < 1">
                Joueur
                <img src="../assets/imgs/emoji-joueur@2x.png">
              </span>
              <span v-else-if="countCampagne < 3">
                Audacieux
                <img src="../assets/imgs/emoji-audacieux@2x.png">
              </span>
              <span v-else>
                Prudent
                <img src="../assets/imgs/emoji-prudent@2x.png">
              </span>
              <br />
              Ce {{ typeAlerte == 'os' ? 'prix' : 'cours' }} a été atteint sur<br />
              {{ countCampagne }} des 5 dernières campagnes.
            </p>
            <v-ons-row>
              <v-ons-col v-for="annee in 5" :key="anneeHisto+annee-1" :class="{'content--perfsimul__active': historique[anneeHisto+annee-1] >= coursObjectif}">
                {{ anneeHisto+annee-1 }}
                <img v-if="historique[anneeHisto+annee-1] >= coursObjectif"
                     src="../assets/imgs/recolte-active@2x.png">
                <img v-else src="../assets/imgs/recolte-inactive@2x.png">
                {{ historique[anneeHisto+annee-1] }}€/t
              </v-ons-col>
            </v-ons-row>
          </div>
          <h2 @click="popupSeuil.isShow = true">{{ coursObjectif }} €/t</h2>
        </section>
      </template>

      <v-ons-bottom-toolbar v-if="isShowReglette" modifier="perfreglette">
        <section @scroll="onScroll" ref="reglette">
          <div>
            <div class="bottom-bar--perfreglette__left" :style="{ width: ((range + offset)*tickWidth - 1) + 'px' }">
              <span v-for="n in (offset ? range/5 : range/5 - 1)" :key="n"
                    :style="{ width: 5*tickWidth + 'px', 'margin-left': (n==1 ? (5/2*tickWidth) + 'px' : 0), 'margin-right': (n==range/5 ? ((offset-5)/2*tickWidth) + 'px' : 0) }">
                {{ coursObjectif == min + n*5 ? '' : min + n*5 }}
              </span>
            </div>
            <div class="bottom-bar--perfreglette__border"></div>
            <div class="bottom-bar--perfreglette__right" :style="{ width: ((range - offset)*tickWidth - 1) + 'px' }">
              <span v-for="n in range/5 - 1" :key="n"
                    :style="{ width: 5*tickWidth + 'px', 'margin-left': (n==1 ? (5/2 - offset)*tickWidth + 'px' : 0) }">
                {{ coursObjectif == min + range + n*5 ? '' : min + range + n*5 }}
              </span>
            </div>
          </div>
        </section>
        <div class="bottom-bar--perfreglette__ligne"></div>
        <div class="bottom-bar--perfreglette__cta">
          <div v-if="isShowHowTo && ! isStepHistorique && ! isShowDiff">
            Faites glisser la réglette<br />
            pour fixer votre alerte
          </div>
          <div v-else-if="isShowHowTo && ! isStepHistorique">
            Faites glisser la réglette<br />
            pour modifier votre alerte
          </div>
          <div v-else-if="isShowHowTo">
            Modifiez votre alerte,<br />
            ou <a href="#" @click="next">Confirmer</a>
          </div>
          <v-ons-button v-else modifier="large--cta perflarge" @click="next">
            <span v-if="! isStepHistorique && coursJour">
              Valider mon alerte
            </span>
            <span v-else>
              Confirmer mon alerte
            </span>
          </v-ons-button>
        </div>
      </v-ons-bottom-toolbar>

    </div>

    <v-ons-action-sheet v-if="prix && coursJour && ! client" :modifier="$mdModifier" :visible.sync="switchPrix" cancelable
                        title="Type d'alerte">
      <v-ons-action-sheet-button :modifier="$mdModifier"
                                 @click="changeTypeAlerte('os')" :style="{ 'font-weight': typeAlerte == 'os' ? 'bold' : 'normal' }">
        prix de votre OS
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button :modifier="$mdModifier"
                                 @click="changeTypeAlerte('cours')" :style="{ 'font-weight': typeAlerte == 'cours' ? 'bold' : 'normal' }">
        cours {{ coursJour.suffix }}
      </v-ons-action-sheet-button>
      <v-ons-action-sheet-button v-if="! $md" @click="switchPrix = false">Fermer</v-ons-action-sheet-button>
    </v-ons-action-sheet>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="popupSeuil.isShow"
                        :cancelable="isShowReglette" ref="popupSeuil" @postshow="setFocusSeuil">
      <template slot="title">
        Seuil d'alerte
      </template>
      <template v-if="isShowReglette">
        &#x1F4A1; Psst, vous pouvez facilement ajuster votre seuil en déplaçant la réglette avec le trait vertical.
      </template>
      <template v-else>
        Votre alerte s'activera automatiquement lorsque les prix seront disponibles.
      </template>
      <v-ons-list modifier="noborder nopadding transparent">
        <app-input input-type="number" v-model.number="popupSeuil.value" placeholder="Entrez un prix"></app-input>
      </v-ons-list>
      <template slot="footer">
        <v-ons-alert-dialog-button @click="cancelSeuil">Annuler</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button modifier="primal" @click="setSeuil">
          Valider
        </v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from "../store.js";

import AppInput from '../partials/Input.vue';

import TWEEN from '@tweenjs/tween.js';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppInput },
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      client: '',
      strategie: {
        objectif: '',
        diff: '',
        echeance: '',
        negoce: '',
        params: {
          is_higher: true,
          is_lower: true
        }
      },
      coursObjectifStep1: '',
      coursObjectif: '',
      min: 0,
      screenWidth: 0,
      range: 50,
      tickWidth: 21,
      scrollX: 0,
      isAnimDone: false,
      isShowHowTo: true,
      isShowDiff: false,
      isShowDelete: false,
      isStepHistorique: false,
      timer: null,
      switchPrix: false,
      typeAlerte: 'cours',
      popupSeuil: {
        isShow: false,
        value: ''
      },
      track: {
        isUpdate: false,
        isPopupSeuil: false
      },
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    clientConnect() {
      return this.state.client;
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    referentiel() {
      return this.data.referentiel;
    },
    destination() {
      return this.referentiel.cultures[this.refCulture].destinations[this.refDestination];
    },
    cultLabel() {
      return this.getCultLabel();
    },
    prix() {
      var prix = null;
      var listPrix = this.getPrixNegoce(this.getNegoceAcces(this.data.negoce.list), this.refCulture, this.refDestination);
      for (let i = 0; i < listPrix.length; i++) {
        var negoceItem = listPrix[i];
        prix = {
          id: negoceItem.id,
          label: negoceItem.label
        };
        for (let j = 0; j < negoceItem.list.length; j++) {
          var prixItem = negoceItem.list[j];
          if(prixItem.cours){
            prix.cours = prixItem.cours;
            prix.base = prixItem.base;
            return prix;
          }
        }
      }
      return prix;
    },
    coursJour() {
      if (this.user.ventes[this.refCulture][this.refDestination].contrat === undefined) {
        var coursName = this.destination.cours;
        var coursData = this.data.cours[coursName];
        var echeanceCurrent = coursData.current;
        var echeanceList = this.getEcheanceList(coursName, this.campagne);
        var echeanceDefault;
        if (this.strategie.echeance) {
          echeanceDefault = this.strategie.echeance;
        } else {
          echeanceDefault = this.getEcheanceDefault(this.campagne, echeanceCurrent, echeanceList);
        }
        if(echeanceDefault < echeanceCurrent){
          return null;
        } else {

          var coursJour = {
            name: coursName,
            suffix: this.getCoursSuffix(coursName)
          };
          var live = this.data.live;
          var coursList = this.getCoursJour(coursName, coursData, live, echeanceList, echeanceDefault);
          if(coursList[echeanceDefault]) {
            coursJour.cours = Math.floor(coursList[echeanceDefault].cours);
            coursJour.echeance = echeanceDefault;
          } else {
            // cas des cours Euronext Récolte annee + n
            coursJour.cours = Math.floor(coursList[echeanceCurrent].cours);
            coursJour.echeance = echeanceCurrent;
          }
          coursJour.label = echeanceList.length ? 'Éch. ' + this.getLabelEcheance(coursJour.echeance) : this.referentiel.cours[coursName].libelle_cours;
          return coursJour;

        }
      }
      return null;
    },
    isShowReglette() {
      return (this.prix && this.prix.cours) || this.coursJour;
    },
    max() {
      return this.min + this.range * 2;
    },
    offset() {
      return this.coursRef % 5;
    },
    coursRef() {
      if (this.prix && this.prix.cours && (this.strategie.negoce || ! this.coursJour) ){
        return Math.floor(this.prix.cours);
      } else if(this.coursJour) {
        return this.coursJour.cours;
      }
    },
    coursInit() {
      if (this.strategie.objectif !== '') {
        if (this.strategie.negoce){
          return this.strategie.objectif;
        } else {
          return this.getCoursFromEffectif(this.strategie.objectif, this.destination, this.strategie.diff);
        }
      } else {
        return this.coursRef;
      }
    },
    historique() {
      if (this.typeAlerte == 'os'){
        var histoBase = '';
        if (this.prix.base !== undefined){ // base définie par l'OS
          histoBase = this.prix.base;
        } else if (this.prix.cours) { // base live calculée
          histoBase = this.prix.cours - this.coursJour.cours;
        } // sinon base par défaut
        var historique = {};
        for (const key in this.referentiel.cours[this.coursJour.name].historique) {
          var histoItem = this.referentiel.cours[this.coursJour.name].historique[key];
          historique[key] = Math.floor(this.getCoursEffectif(histoItem, this.destination, histoBase));
        }
        return historique;
      } else {
        return this.referentiel.cours[this.coursJour.name].historique;
      }
    },
    anneeHisto() {
      return Object.keys(this.historique).reduce(function (max, annee) { return parseInt(annee) && annee > max ? annee : max }, 0) - 4;
    },
    countCampagne() {
      var count = 0;
      for (let annee = this.anneeHisto; annee < this.anneeHisto + 5; annee++) {
        if (this.historique[annee] >= this.coursObjectif) {
          count += 1;
        }
      }
      return count;
    },
    diffBgColor() {
      var gradient = Math.min(this.coursObjectif - this.coursRef, 30) / 30;
      gradient = Math.max(gradient, 0);
      return 'rgb(' + parseInt(255-gradient*(255-255)) + ',' + parseInt(201-gradient*(201-0)) + ',' + parseInt(67-gradient*(67-0)) + ')';
    },
    trackInfos() {
      return 'alerte ' + this.refCulture + ' ' + this.refDestination;
    }
  },
  watch: {
    scrollX(value) {
      this.$refs.reglette.scrollLeft = value;
    },
    'popupSeuil.isShow'(value) {
      if(! this.isShowReglette){
        this.popupSeuil.value = this.strategie.objectif;
      } else if(value){
        this.popupSeuil.value = this.coursObjectif;
      }
    }
  },
  methods: {
    backButton() {
      if (this.isStepHistorique) {
        this.isStepHistorique = false;
        this.isShowHowTo = false;
      } else {
        this.pageStack.length > 1 && this.pageStack.pop();
      }
    },
    initPage() {
      if(! this.isShowReglette){
        return;
      }
      this.screenWidth = this.$refs.reglette.offsetWidth;
      // initScroll
      if(this.isAnimDone){
        var newScroll = (this.range + this.offset + (this.coursObjectif - this.coursRef)) * this.tickWidth - (this.screenWidth / 2);
        this.scrollX = newScroll;
      }
    },
    showPage() {
      // initScroll
      if(this.isShowReglette && ! this.isAnimDone){
        var newScroll = (this.range + this.offset + (this.coursObjectif - this.coursRef)) * this.tickWidth - (this.screenWidth / 2);
        this.tween(newScroll - this.screenWidth/2, newScroll, 400);
      }
    },
    onScroll(event) {
      var coursObjectif = this.min + Math.round((event.target.scrollLeft + (this.screenWidth / 2)) / this.tickWidth);
      if(! this.isAnimDone){
        if(coursObjectif == this.coursInit){
          this.isAnimDone = true;
        } else {
          return;
        }
      }
      if (coursObjectif != this.coursObjectif && coursObjectif != this.coursInit) {
        this.isShowHowTo = false;
        this.isShowDiff = true;
      }
      this.coursObjectif = coursObjectif;
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        var initScroll = event.target.scrollLeft;
        var newScroll = (this.coursObjectif - this.min) * this.tickWidth - (this.screenWidth / 2);
        if (parseInt(newScroll) != Math.round(initScroll)) {
          this.tween(initScroll, newScroll, 50);
        }
        //this.scrollX = newScroll;
      }, 150);
    },
    next() {
      if(this.client){
        if(! store.state.user.ventes[this.refCulture][this.refDestination].clients){
          this.$set(store.state.user.ventes[this.refCulture][this.refDestination], 'clients', {});
        }
        if(! store.state.user.ventes[this.refCulture][this.refDestination].clients[this.client]){
          this.$set(store.state.user.ventes[this.refCulture][this.refDestination].clients, this.client, {});
        }
        this.$set(store.state.user.ventes[this.refCulture][this.refDestination].clients[this.client], 'objectif', this.coursObjectif);
        this.ionicStorage.set('user', this.user);

        this.$emit('call-api', {
          call: {
            path: this.getPath('/tc/alerte'),
            data: {
              id: this.user.id,
              date: this.user.date,
              ref_culture: this.refCulture,
              ref_destination: this.refDestination,
              client: this.client,
              data: {
                objectif: this.coursObjectif
              }
            }
          }
        });

        if(this.clientConnect.id){
          this.pageStack.length > 1 && this.pageStack.pop();
        } else {
          this.pageStack.length > 2 && this.pageStack.splice(this.pageStack.length - 2, 2);
        }

        return;
      }
      var isShowNextStep = false;
      var trackInfos = {
        suffix: this.typeAlerte + ' ' + this.coursObjectifStep1,
        popup: this.track.isPopupSeuil ? ' popup' : ''
      }
      if(! this.isStepHistorique) {
        if(! this.coursObjectifStep1) {
          // si AR track uniquement sur la 1ère valeur
          this.coursObjectifStep1 = this.coursObjectif;
          trackInfos.suffix = this.typeAlerte + ' ' + this.coursObjectifStep1;
          if(! this.track.isUpdate){
            this.sendTrackEvent(this.trackInfos + ' set ' + trackInfos.suffix + trackInfos.popup);
            // sinon tracking sur tout le workflow
            this.track.isPopupSeuil = false;
          }
        }
        if(this.coursJour){
          this.isStepHistorique = true;
          this.isShowHowTo = true;
          isShowNextStep = true;
        }
      } else {
        if(! this.track.isUpdate){
          this.sendTrackEvent(this.trackInfos + ' save ' + trackInfos.suffix + ' ' + this.coursObjectif + trackInfos.popup);
        }
      }
      if(this.track.isUpdate){
        this.sendTrackEvent(this.trackInfos + ' update ' + trackInfos.suffix + ' ' + this.coursObjectif + trackInfos.popup); 
      }

      this.setStrategie(this.coursObjectif);

      this.mergeJson(store.state.user.ventes[this.refCulture][this.refDestination], this.strategie);
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          path: this.getPath('/alerte'),
          data: {
            id: this.user.id,
            date: this.user.date,
            ref_culture: this.refCulture,
            ref_destination: this.refDestination,
            data: this.strategie
          }
        }
      });

      if(isShowNextStep){
        return;
      }
      if(!this.track.isUpdate) {
        if(this.nbFeuille == 1){
          store.state.onboarding.nbFeuille += 1;
          this.ionicStorage.set('onboarding', this.state.onboarding);
          store.state.badge.type = 'feuille';
          this.sendTrackEvent('onboarding feuille ' + this.nbFeuille);
        }
        this.$emit('set-push-ok');
      }

      this.pageStack.length > 1 && this.pageStack.pop();
    },
    tween(start, end, duration) {
      let frameHandler

      // Handles updating the tween on each frame.
      const animate = function (currentTime) {
        TWEEN.update(currentTime)
        frameHandler = requestAnimationFrame(animate)
      }

      const myTween = { value: start };
      new TWEEN.Tween(myTween)
        .to({ value: end }, duration)
        //.easing(TWEEN.Easing.Quadratic.Out)
        // Be careful to not to do too much here! It will slow down the app.
        .onUpdate(() => {
          this.scrollX = parseInt(myTween.value)
        })
        .onComplete(() => {
          // Make sure to clean up after ourselves.
          cancelAnimationFrame(frameHandler)
        })
        // This actually starts the tween.
        .start()

      frameHandler = requestAnimationFrame(animate)
    },
    changeTypeAlerte(type) {
      this.typeAlerte = type;
      this.switchPrix = false;

      this.setStrategie('');

      this.createPage();
      this.initPage();
      this.isShowDiff = false;
    },
    setStrategie(coursObjectif) {
      if (this.typeAlerte == 'os'){
        if (! this.strategie.negoce){
          this.strategie.negoce = {};
          this.strategie.negoce[this.prix.id] = [];
        }
        this.strategie.objectif = coursObjectif;
      } else {
        this.strategie.negoce = null;
        this.strategie.objectif = this.getCoursEffectif(coursObjectif, this.destination, this.strategie.diff);
      }
    },
    createPage() {
      this.coursObjectif = this.coursInit;

      this.min = parseInt(this.coursRef / 5) * 5 - this.range;

      // Adapte min/range si nécessaire
      var min = this.coursInit;
      if(this.coursJour){
        min = Math.min(this.historique.min, min);
      }
      min -= 20;
      if (this.min > min) {
        var diffMin = Math.ceil((this.min - min) / 5) * 5;
        this.min -= diffMin;
        this.range += diffMin;
      }
      var max = this.coursInit;
      if(this.coursJour){
        max = Math.max(this.historique.max, max);
      }
      max += 20;
      if (this.max < max) {
        var diffMax = Math.ceil((max - this.max) / 5) * 5;
        this.min -= diffMax;
        this.range += diffMax;
      }
    },
    setFocusSeuil() {
      this.showKeyboard();
      this.$setAutoFocus(this.$refs.popupSeuil.$el, 'ons-input');
    },
    setSeuil() {
      if (! this.isShowReglette) {
        if(! this.popupSeuil.value){
          this.coursObjectif = '';
        } else {
          this.coursObjectif = Math.floor(this.popupSeuil.value);
        }
        this.next();
      } else {
        this.popupSeuil.isShow = false;
        this.coursObjectif = Math.min(this.max, Math.max(this.min, Math.floor(this.popupSeuil.value)));
        var initScroll = this.$refs.reglette.scrollLeft;
        var newScroll = (this.coursObjectif - this.min) * this.tickWidth - (this.screenWidth / 2);
        this.tween(initScroll, newScroll, 400);
        this.track.isPopupSeuil = true;
      }
    },
    cancelSeuil() {
      if (! this.isShowReglette) {
        this.pageStack.length > 1 && this.pageStack.pop();
      } else {
        this.popupSeuil.isShow = false;
      }
    },
    deleteAlerteConfirm() {
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Attention !',
        message: "Êtes-vous sûr de vouloir supprimer cette alerte ?",
        buttonLabels: ['Annuler', 'Supprimer'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteAlerte();
          }
        }.bind(this)
      });
    },
    deleteAlerte() {
      store.state.user.ventes[this.refCulture][this.refDestination].clients[this.client].objectif = '';
      this.ionicStorage.set('user', this.user);
      this.$emit('call-api', {
        call: {
          path: this.getPath('/tc/alerte'),
          data: {
            id: this.user.id,
            date: this.user.date,
            ref_culture: this.refCulture,
            ref_destination: this.refDestination,
            client: this.client,
            data: {
              objectif: ''
            }
          }
        }
      });
      if(this.clientConnect.id){
        this.pageStack.length > 1 && this.pageStack.pop();
      } else {
        this.pageStack.length > 2 && this.pageStack.splice(this.pageStack.length - 2, 2);
      }
    }
  },
  created() {
    var strategie = this.user.ventes[this.refCulture][this.refDestination];
    if(this.client){
      this.typeAlerte = 'os';
      this.strategie.negoce = {};
      if(strategie.clients && strategie.clients[this.client] && strategie.clients[this.client].objectif){
        this.track.isUpdate = true;
        this.isShowDiff = true;
        this.strategie.objectif = strategie.clients[this.client].objectif;
        this.isShowDelete = this.isShowReglette;
      }
    } else {
      if (strategie.objectif) {
        this.track.isUpdate = true;
        //this.isAnimDone = true;
        this.isShowDiff = true;
        if (strategie.negoce && this.prix){
          // init du choix
          this.typeAlerte = 'os';
        }
        this.setJson(this.strategie, strategie);
      } else if (this.prix){
        // par défaut alerte Prix OS
        this.typeAlerte = 'os';
        this.setStrategie('');
      }
      if(! this.coursJour){
        // pas de choix
        this.typeAlerte = 'os';
      }
    }

    if(! this.isShowReglette){
      this.popupSeuil.isShow = true;

      if(! this.track.isUpdate && ! this.client){
        this.sendTrackEvent(this.trackInfos + ' show ' + this.typeAlerte + ' popup');
      }
    } else {
      this.createPage();

      if(! this.track.isUpdate && ! this.client){
        this.sendTrackEvent(this.trackInfos + ' show ' + this.typeAlerte + ' ' + this.coursInit);
      }
    }

  }
};
</script>

<style scoped>
.toolbar-button--perfrecolte:active {
  background-color: var(--perfarmer-jaune);
}
</style>

<style>
.page--perfvert__background {
  background-image: linear-gradient(var(--perfarmer-vert), #242c29);
}
.page--perfreglette__background {
  background-image: linear-gradient(var(--perfarmer-vert), #242c29);
  margin-bottom: 200px;
}
.bottom-bar--perfreglette {
  background-color: white;
  height: auto;
  border-top: solid 1px var(--perfarmer-gris-light);
}
.bottom-bar--perfreglette > section {
  overflow-x: scroll;
  background-image: linear-gradient(#242c29, #282828);
}
.bottom-bar--perfreglette > section > div {
  display: inline-flex;
}
.bottom-bar--perfreglette > section > div > div {
  height: 83px;
}
.bottom-bar--perfreglette__border {
  width: 2px;
  background-color: var(--perfarmer-jaune);
  z-index: 5;
}
.bottom-bar--perfreglette__left {
  z-index: 3;
  background: url("../assets/imgs/reglette_app@2x.png") top left / contain repeat;
}
.bottom-bar--perfreglette__right {
  z-index: 3;
  background: url("../assets/imgs/reglette_app@2x.png") top right / contain repeat;
}
.bottom-bar--perfreglette > section span {
  display: inline-block;
  text-align: center;
  color: white;
  margin-top: 45px;
}
.bottom-bar--perfreglette__ligne {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 0;
  width: 2px;
  z-index: 4;
  height: 83px;
  background-color: white;
}
.bottom-bar--perfreglette__cta {
  padding: 28px 15px;
  background-color: white;
}
.content--perfcartouche {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto -22px;
  bottom: 200px;
  width: 260px;
  box-sizing: border-box;
  z-index: 3;
  padding: 22px;
  text-align: center;
  background-color: white;
  border-radius: 6px;
}
.content--perfcartouche h2 {
  margin: 0 0 14px;
  font-size: 28px;
  line-height: 33px;
  font-weight: 500;
  color: var(--perfarmer-vert);
}
.content--perfcartouche p {
  margin: 0 0 3px;
  font-size: 14px;
  line-height: 22px;
}
.content--perfcartouche p b {
  font-size: 16px;
}
.content--perfcartouche p span {
  padding: 4px 8px 2px;
  border-radius: 12px;
  color: white;
}
.content--perfcartouche div {
  width: 16px;
  height: 16px;
  background-color: white;
  transform: rotate(45deg);
  position: absolute;
  bottom: -8px;
  left: 122px;
}
.content--perfalerte {
  margin: 0 52px;
  height: calc(100% - 300px);
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
}
.content--perfalerte img {
  height: 50px;
}
.content--perfalerte p {
  font-size: 19px;
  line-height: 28px;
  color: white;
  text-align: center;
  margin: 20px 0 0;
}
.content--perfsimul {
  text-align: center;
  margin: 16px 15px 30px;
  height: calc(100% - 296px);
}
.content--perfsimul > div {
  background: white;
  border-radius: 6px;
  height: 100%;
  max-height: 315px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.content--perfsimul > div > p {
  font-size: 19px;
  line-height: 28px;
  margin: 0 0 26px;
}
.content--perfsimul > div > p img {
  height: 22px;
  vertical-align: text-top;
}
.content--perfsimul > div ons-row {
  max-width: 295px;
  margin: 0 auto;
}
.content--perfsimul > div ons-col {
  padding: 0 5px;
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: var(--perfarmer-gris-normal);
}
.content--perfsimul > div ons-col img {
  width: 100%;
  max-width: 60px;
  display: block;
}
.content--perfsimul > div ons-col.content--perfsimul__active {
  color: var(--perfarmer-vert);
}
.content--perfsimul > h2 {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto 20px;
  bottom: 200px;
  width: 200px;
  font-size: 28px;
  line-height: 33px;
  color: white;
}

.alert-dialog-content--perfbadge .list-item--input {
  margin-top: 10px;
}

html[onsflag-iphonex-portrait] .page--perfreglette__background {
  margin-bottom: 234px;
}
html[onsflag-iphonex-portrait] .content--perfcartouche {
  margin-bottom: 12px;
}
html[onsflag-iphonex-portrait] .bottom-bar--perfreglette__ligne {
  margin-bottom: 34px;
}
html[onsflag-iphonex-portrait] .content--perfsimul > h2 {
  margin-bottom: 54px;
}
</style>
